import { useMutation } from '@tanstack/react-query';
import { feedbackApi } from '@/api/feedback';
import type { FeedbackInput } from '@/types';

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: (feedback: FeedbackInput) => feedbackApi.submit(feedback),
  });
}
